// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table td {
  padding: 7px;
}

table {
  width: 100%;
}

.navbar {
  background-color: #fff;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
}

li a {
  font-size: 16px !important;
  font-weight: bold;
  color: black;
}

li a:hover {
  color: blue;
  border-bottom: 2px solid blue;
}

.profile {
  top: 80px;
}

.card {
  width: 100%;
}

.mt-110 {
  margin-top: 110px;
}

#footer {
  background-color: #fff;
  border-top: 1px solid;
  padding-bottom: 10px;
  padding-top: 10px;
}

.fa-check {
  color: green;
}

.fa-times {
  color: red;
}

.card-header {
  background-color: #8e0b56;
}

.card-header .h5 {
  color: #fff;
}

.result-head-td {
  background: #8e0b56;
  color: #fff;
}

.result-card {
  border: 0px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.18);
}

.same-votes {
  background-color: #c3edc3;
}

.same-votes-false {
  background-color: #f1d7d7;
}

.red {
  background-color: rgb(241, 215, 215);
}

.green {
  background-color: rgb(195, 237, 195);
}

.yellow {
  background-color: rgb(233, 237, 87);
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/website/result/result.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAGA;EACI,sBAAA;EACA,yCAAA;AAAJ;;AAEA;EACI,0BAAA;EACA,iBAAA;EACA,YAAA;AACJ;;AACA;EACI,WAAA;EACA,6BAAA;AAEJ;;AACA;EACI,SAAA;AAEJ;;AAAA;EACI,WAAA;AAGJ;;AAAA;EACI,iBAAA;AAGJ;;AAAA;EACI,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;AAGJ;;AAAA;EACI,YAAA;AAGJ;;AADA;EACI,UAAA;AAIJ;;AADA;EAAa,yBAAA;AAKb;;AAJA;EAAiB,WAAA;AAQjB;;AAPA;EACI,mBAAA;EACA,WAAA;AAUJ;;AARA;EACI,WAAA;EACA,0CAAA;AAWJ;;AATA;EAAY,yBAAA;AAaZ;;AAZA;EAAkB,yBAAA;AAgBlB;;AAdA;EACI,oCAAA;AAiBJ;;AAdA;EACI,oCAAA;AAiBJ;;AAbA;EACI,mCAAA;AAgBJ;AACA,g1EAAg1E","sourcesContent":["table td{\n    padding: 7px;\n}\n\ntable{\n    width: 100%;\n}\n\n\n.navbar {\n    background-color: #fff;\n    box-shadow: 0 2px 2px rgba(0, 0, 0, .05);\n}\nli a{\n    font-size: 16px !important;\n    font-weight: bold;\n    color: black;\n}\nli a:hover{\n    color: blue;\n    border-bottom: 2px solid blue;\n}\n\n.profile {\n    top: 80px;\n}\n.card{\n    width: 100%;\n}\n\n.mt-110{\n    margin-top: 110px;\n}\n\n#footer{\n    background-color: #fff;\n    border-top: 1px solid;\n    padding-bottom: 10px;\n    padding-top: 10px;\n}\n\n.fa-check{\n    color: green;\n}\n.fa-times{\n    color: red;\n}\n\n.card-header{background-color: #8e0b56;}\n.card-header .h5{color: #fff;}\n.result-head-td{\n    background: #8e0b56;\n    color: #fff;\n}\n.result-card{\n    border:0px;\n    box-shadow:0 0 20px 0 rgba(0,0,0,0.18);\n}\n.same-votes{background-color: #c3edc3;}\n.same-votes-false{background-color: #f1d7d7;}\n\n.red{\n    background-color: rgb(241, 215, 215);\n}\n\n.green{\n    background-color: rgb(195, 237, 195);\n}\n\n\n.yellow{\n    background-color: rgb(233, 237, 87);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
